import { useState, useRef } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import QuestionList from '../QuestionList';

function FaqBeddingAccordion() {

    const panel1Ref = useRef(null);
    const panel2Ref = useRef(null);
    const panel3Ref = useRef(null);
    const panel4Ref = useRef(null);
    const panel5Ref = useRef(null);

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel, panelRef) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
        // if (isExpanded && panelRef.current) {
        //     // panelRef.current.scrollTo({ behavior: 'smooth', block: 'start' });
        //     window.scrollTo(0,500);
        // }
        setTimeout(() => {
            window.scroll({
                top: panelRef.current?.offsetTop - (document.querySelector('.bs-header').clientHeight + 50),
                behavior: 'smooth'
            }) 
        }, 500)
    };

    const accountManagementQueries = [
        {
            id: 1,
            question: 'How can I create an account?',
            answer: "<p>You can effortlessly create an account by signing up on our website. Simply enter your email address and mobile number, and your account will be created instantly.</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 2,
            question: 'Do I need an account to shop for Sansaar bedding?',
            answer: "<p>No, you don’t need an account to shop for Sansaar bedding—you can simply check out as a guest. However, creating an account gives you access to added benefits, including:</p>",
            features: null,
            meta: null,
            info: null,
            bullets: [
                {
                    id:1,
                    text:'Saving items to your Wishlist'
                },
                {
                    id:2,
                    text:'Unlock exclusive discounts and early access to special offers.'
                },
                {
                    id:3,
                    text:'Checking your order status and viewing past orders'
                },
            ]
        },
        {
            id: 3,
            question: 'How do I change my email or password?',
            answer: "<p>To update your email, go to <b>'My Account'</b>, then <b>'Profile'</b>, and click the <b>'Edit'</b> button to make changes.<br/>If you want to change your password, use the <b>'Forgot your password?'</b> link on the sign-in page to reset it securely.</p>",
            features: null,
            meta: null,
            info: null,
            bullets:null
        }
    ]

    const orderAndTrackingData = [
        {
            id: 1,
            question: 'When will I receive my order?',
            answer: "<p>Orders are usually processed within 24 hours. Once shipped, delivery timelines may vary based on your location, but most orders are delivered within 4–5 business days from the date of purchase. You'll receive tracking details as soon as your order is dispatched.</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 2,
            question: 'How do I track my package?',
            answer: '<p>You will receive a confirmation email once your order has been successfully processed. This email will include your order details and tracking information once your shipment has been dispatched from our warehouse.<br/>You can also track your order by signing into <b>My Account</b> and clicking on <b>My Orders</b>. Your order history will be displayed there, and you’ll find a tracking link for each order.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 3,
            question: 'How do I cancel my order?',
            answer: '<p>You can cancel your order any time before it ships from our warehouse. If the order has already been shipped, you’ll need to place a return request instead. Please ensure the item is in its original retail packaging. View our full Return Policy. For further assistance, please contact our Customer Service at <a href="tel:8655712561">8655712561</a> (Monday - Saturday 9AM to 6PM) or mail us <a href="mailto:support@sansaar.co.in">support@sansaar.co.in</a></p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 4,
            question: 'How do I exchange an item purchased online?',
            answer: '<p>To request an exchange or refund, please email us at <a href="mailto:services@sansaar.co.in">services@sansaar.co.in</a> with your order ID, mobile number, and details of the product(s) you wish to exchange. Our team will review your request and get back to you with an approval. Kindly ensure that the product is in its original condition and retail packaging during the return. For more details, please refer to our Return Policy.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 5,
            question: 'What payment methods are accepted?',
            answer: '<p>We currently accept UPI, Credit Cards, Debit Cards, Net Banking, and all major digital wallet options.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 6,
            question: 'If I get a defective/damaged product, will Sansaar.co.in replace it?',
            answer: '<p>If you receive a defective product, it will be eligible for return or replacement. Please contact our Customer Service team at <a href="tel:8655712561">8655712561</a> (Monday to Saturday, 9 AM to 6 PM) or email us at <a href="mailto:services@sansaar.co.in">services@sansaar.co.in</a> within 48 hours of receiving the item. Even customized products will be replaced if there is a genuine defect. Returns for other items will be processed after proper verification. For full details, please refer to our Return Policy.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
    ]

    const shippingQueriesData = [
        {
            id: 1,
            question: 'What are the shipping charges on Sansaar Bedding products?',
            answer: "<p>There are no additional shipping fees - shipping charges are already included in the product price.</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 2,
            question: 'How long does an order take to ship to my destination?',
            answer: "<p>For all prepaid orders made through an online payment method, you will receive your order packet within 4-5 business days from the date of order confirmation, depending on the location of the delivery. These products will be shipped by surface courier.</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 3,
            question: 'My items haven\'t arrived yet. What can I do?',
            answer: '<p>You can track your order by signing into <b>My Account</b> and clicking on <b>My Orders</b>. Your order history will be displayed there, and you’ll find a <b>tracking link</b> for each order.  For further assistance, please contact our Customer Service at <a href="tel:8655712561">8655712561</a> (Monday - Saturday 9AM to 6PM) or mail us <a href="mailto:support@sansaar.co.in">support@sansaar.co.in</a></p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 4,
            question: 'Do you ship outside India?',
            answer: '<p>At the moment, we are shipping only in India. But we accept all International Credit Cards to ship anywhere in India. Also, we are working towards getting you a world-wide shipping in the near future.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
    ]

    const returnQueriesData = [
        {
            id: 1,
            question: 'What do I do if I have received a wrong item?',
            answer: "<p>For any issues with your order, including damaged or incorrect items, please contact our Customer Service team at <a href='tel:8655712561'>8655712561</a> (Monday to Saturday, 9 AM to 6 PM) or email us at <a href='mailto:services@sansaar.co.in'>services@sansaar.co.in</a> within 48 hours of receiving the item. Returns for other items will be processed after due diligence and verification. Please note that customized products are non-returnable.</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 2,
            question: 'How can I start a return?',
            answer: "<p>Please review our Returns Policy and follow directions for starting a return for a purchase made on Sansaar.co.in</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 3,
            question: 'How long will it take to process my refund?',
            answer: '<p>Refunds for returns are generally processed within 4-5 days from the date the returning items are received. Once processed, the money may appear in your account within 2-3 business days depending on the bank. See our Returns Policy for more details.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 4,
            question: 'How will I be refunded ?',
            answer: '<p>All the refunds will be issued through the same transaction method used in the original purchase.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 5,
            question: 'Will I have to pay for shipping the product back to you?',
            answer: '<p>No, there will be no shipping charges. To make our returns process hassle-free for you, we arrange a reverse pick-up for every product which is wrong-fully delivered or is found defective/damaged by you. All you need to do is inform our Customer Service at <a href="tel:8655712561">8655712561</a> (Monday - Saturday  9AM to 6PM) or mail us at <a href="mailto:services@sansaar.co.in">services@sansaar.co.in</a> For any further details please go through our Return Policy.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
    ]

    const productQueryData = [
        {
            id: 1,
            question: 'What is a Wishlist?',
            answer: '<p>The Wishlist keeps track of products you love and want. To start your Wishlist, you will first need to be registered with Sansaar.co.in. While you are browsing through the website, you can bookmark your favourite products by going into their details page and clicking the Wishlist checkbox. You can sign in to your account any time later, go to <b>Wishlist</b> and can directly place an order from there.</p>',
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 2,
            question: 'How do I find if a product is available in stock?',
            answer: "<p>Availability of each product is mentioned on the product page. If it is not available, it will show 'Coming Soon’.</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 3,
            question: 'Where are your stores located?',
            answer: "<p>Yes, we have a PAN India presence in over 300 + stores. You can check the store locations through our <a href='/where-to-buy'>Store locator.</a></p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 4,
            question: 'What all bedding products are available?',
            answer: "<p>Sansaar offers a variety of bedding products, including:</p>",
            features: [
                {
                    id: 1,
                    icon: 'bedsheet',
                    title: 'Bed <br/> Sheets'
                },
                {
                    id: 2,
                    icon: 'duvet',
                    title: 'Duvet <br/> Covers'
                },
                {
                    id: 3,
                    icon: 'comfortor',
                    title: 'Comforters'
                },
                {
                    id: 4,
                    icon: 'cushion-cover',
                    title: 'Bedspreads'
                },
                {
                    id: 5,
                    icon: 'pillow-cover',
                    title: 'Pillow <br/> covers'
                },
                {
                    id: 6,
                    icon: 'bed-in-bag',
                    title: 'Bed-in-a-bag <br/> sets'
                }
            ],
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
        {
            id: 5,
            question: 'What sizes are your bedding products available in?',
            answer: "<p>We offer our bedding in the following standard sizes:</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: true
        },
        {
            id: 6,
            question: 'How should I wash and care for my bedding?',
            answer: "<p>Most of our bedding is machine washable in cold or warm water on a gentle cycle. For drying, tumble dry on low heat or air dry. Some items may require dry cleaning. For detailed care instructions, please refer to the wash care tags included with each product.</p>",
            features: null,
            meta: null,
            info: null,
            bullets: null,
            sizeChart: false
        },
    ]

   

    return (
        <div className='bs-accordion'>
            <Accordion ref={panel1Ref} expanded={expanded === 'panel1'} onChange={handleChange('panel1', panel1Ref)} className='bs-accordion__item'>
                <AccordionSummary
                    expandIcon={<span className='bs-accordion__icon icon icon-down'></span>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className='bs-accordion__item-title-wrap'
                >
                    <h3 className='bs-accordion__title'>Account Management Queries</h3>
                </AccordionSummary>
                <AccordionDetails className='bs-accordion__item-cont-wrap'>
                    <QuestionList data={accountManagementQueries} />
                </AccordionDetails>
            </Accordion>
            <Accordion ref={panel2Ref} expanded={expanded === 'panel2'} onChange={handleChange('panel2', panel2Ref)} className='bs-accordion__item'>
                <AccordionSummary
                    expandIcon={<span className='bs-accordion__icon icon icon-down'></span>}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                    className='bs-accordion__item-title-wrap'
                >
                    <h3 className='bs-accordion__title'>Orders and Tracking Queries</h3>
                </AccordionSummary>
                <AccordionDetails className='bs-accordion__item-cont-wrap'>
                    <QuestionList data={orderAndTrackingData} />
                </AccordionDetails>
            </Accordion>
            <Accordion ref={panel3Ref} expanded={expanded === 'panel3'} onChange={handleChange('panel3', panel3Ref)} className='bs-accordion__item'>
                <AccordionSummary
                    expandIcon={<span className='bs-accordion__icon icon icon-down'></span>}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                    className='bs-accordion__item-title-wrap'
                >
                    <h3 className='bs-accordion__title'>Shipping Queries</h3>
                </AccordionSummary>
                <AccordionDetails className='bs-accordion__item-cont-wrap'>
                    <QuestionList data={shippingQueriesData} />
                </AccordionDetails>
            </Accordion>
            <Accordion ref={panel4Ref} expanded={expanded === 'panel4'} onChange={handleChange('panel4', panel4Ref)} className='bs-accordion__item'>
                <AccordionSummary
                    expandIcon={<span className='bs-accordion__icon icon icon-down'></span>}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                    className='bs-accordion__item-title-wrap'
                >
                    <h3 className='bs-accordion__title'>Return Queries</h3>
                </AccordionSummary>
                <AccordionDetails className='bs-accordion__item-cont-wrap'>
                    <QuestionList data={returnQueriesData} />
                </AccordionDetails>
            </Accordion>
            <Accordion ref={panel5Ref} expanded={expanded === 'panel5'} onChange={handleChange('panel5', panel5Ref)} className='bs-accordion__item'>
                <AccordionSummary
                    expandIcon={<span className='bs-accordion__icon icon icon-down'></span>}
                    aria-controls="panel5bh-content"
                    id="panel5bh-header"
                    className='bs-accordion__item-title-wrap'
                >
                    <h3 className='bs-accordion__title'>Product Queries</h3>
                </AccordionSummary>
                <AccordionDetails className='bs-accordion__item-cont-wrap'>
                    <QuestionList data={productQueryData} />
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default FaqBeddingAccordion